import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class TimeUtil {
  /**
   * Retorna la fecha que resulta de sumar 'months' meses a hoy, como objeto Date
   */
  getDateAfterMonths(months: number): Date {
    const date = new Date();
    date.setMonth(date.getMonth() + months);
    return date;
  }
  /**
   * Retorna la fecha que resulta de sumar 'days' días a hoy, como objeto Date
   */
  getDateAfterDays(days: number): Date {
    const date = new Date();
    date.setDate(date.getDate() + days);
    return date;
  }
  /**
   * Retorna la fecha de mañana como objeto Date
   */
  getTomorrowDate(): Date {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow;
  }
  constructor() {}

  getLastDateRangeFromDays(days: number): {
    startDate: Date;
    endDate: Date;
  } {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(endDate.getDate() - days);

    return {
      startDate,
      endDate,
    };
  }

  getLastMonthsDateRange(months: number): {
    startDate: Date;
    endDate: Date;
  } {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setMonth(endDate.getMonth() - months);

    return {
      startDate,
      endDate,
    };
  }

  /**
   * Returns the date that results from subtracting 'days' days from today, as a Date object
   */
  getDateBeforeDays(days: number): Date {
    const date = new Date();
    date.setDate(date.getDate() - days);
    return date;
  }

  /**
   * Formatea una fecha como yyyy-mm-dd en zona local.
   * Acepta Date o string (yyyy-mm-dd, yyyy/mm/dd, etc).
   */
  formatDateLocalYYYYMMDD(dateOrString: Date | string): string {
    let date: Date;
    if (typeof dateOrString === "string") {
      // Si es string tipo yyyy-mm-dd, parsea como local
      const match = dateOrString.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (match) {
        // Mes en JS es base 0
        date = new Date(
          Number(match[1]),
          Number(match[2]) - 1,
          Number(match[3])
        );
      } else {
        // Otros formatos, intenta parsear normal
        date = new Date(dateOrString);
      }
    } else {
      date = dateOrString;
    }
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  }
}
